import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {Button} from 'react-bootstrap';
import {useNavigate} from 'react-router';
import {isWithinJoinWindow} from '../consultation/deepLinks';

export default function ReservationCard({
  id,
  timezone,
  reservationTime,
  doctor,
  hasVideoRoom,
  paymentDue,
  payBy,
  released,
  showReservationDetail,
}) {
  const navigate = useNavigate();
  const content = {
    margin: '0',
    color: '#dc3545',
    fontWeight: 'bold',
  };

  const line = {...content, display: 'block'};

  return (
    <li className="content-card-element">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          color: '#474747',
        }}
      >
        <button
          type="button"
          onClick={() => showReservationDetail(id)}
          style={{background: 'none', border: 'none', padding: 0, textAlign: 'left', width: '100%'}}
        >
          <span style={line}>{timezone}</span>
          <span style={{...line, fontSize: '1.5rem'}}>
            {dayjs(reservationTime).format('YYYY-MM-DD HH:mm')}
          </span>
          <span style={{...line, fontSize: '1.5rem'}}>{doctor}</span>
          {released && (
            <span className="badge bg-secondary" style={{alignSelf: 'flex-start', marginTop: '0.25rem'}}>
              Released
            </span>
          )}
          {paymentDue && <span style={line}>Payment due</span>}
          {payBy && <span style={line}>{`Pay by ${dayjs(payBy).format('YYYY-MM-DD HH:mm')}`}</span>}
        </button>
        {hasVideoRoom && isWithinJoinWindow(reservationTime) && (
          <Button
            variant="success"
            size="sm"
            style={{marginTop: '0.5rem', alignSelf: 'flex-start'}}
            onClick={() => navigate(`/virtual-consultation/room/${id}`)}
          >
            Join Room
          </Button>
        )}
      </div>
    </li>
  );
}

ReservationCard.propTypes = {
  id: PropTypes.string,
  timezone: PropTypes.string,
  reservationTime: PropTypes.string,
  doctor: PropTypes.string,
  hasVideoRoom: PropTypes.bool,
  paymentDue: PropTypes.bool,
  payBy: PropTypes.string,
  released: PropTypes.bool,
  showReservationDetail: PropTypes.func,
};
